import axios from "axios";
import React, {FC, useState} from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { login } from "../api/AuthApi";
import { setLogin } from "../reducers/AuthSlice";
import "../assets/styles/styles.scss";
import { Link } from "react-router-dom";

const Login: FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [ usrId, setUsrId ] = useState('');
  const [ usrPw, setUsrPw ] = useState('');
  const [ isError, setIsError ] = useState(false);
  const [ errorMsg, setErrorMsg ] = useState('');

  const loginAction = async (event: any) => {
    event.preventDefault();
    if (!checkValidation(usrId, '아이디를 입력하세요.')) return;
    if (!checkValidation(usrPw, '비밀번호를 입력하세요.')) return;    
    try {
      const res = await login({ usrId, usrPw });
      dispatch(setLogin(res.data));
      initValue();
      navigate("/");
    } catch(err: any) {
      if (axios.isAxiosError(err) && err.response?.status === 401) {
        setError(err.response?.data.message);
        return;
      } 
      setError("서버 에러! 관리자에게 문의하세요.");
    }
  };

  const checkValidation = (target: string, msg: string) => {
    if (!target?.trim()) {
      setError(msg);
      return false;
    }
    return true;
  };

  const setError = (msg: string) => {
    setIsError(true);
    setErrorMsg(msg);
  }

  const initValue = () => {
    setUsrId('');
    setUsrPw('');
    setIsError(false);
  }

  return (
    <form onSubmit={loginAction}>
        <input id="usrId" value={usrId} 
          onKeyDown={() => setIsError(false)}
          onChange={(event) => setUsrId(event.target.value)} 
          className={'login-input'} type="text" placeholder="아이디"/>

        <input id="usrPw" value={usrPw} 
          onKeyDown={() => setIsError(false)}
          onChange={(event) => setUsrPw(event.target.value)} 
          className={'login-input'} type="password" placeholder="비밀번호" autoComplete="on" />

        <div className={'error-text'}>
          { isError && 
            <span>{errorMsg}</span>
          }
        </div>
        
        <button onClick={loginAction} className={'login-button d-block'}>
          <span>로그인</span>
        </button>
        <Link to={'/find/id'} className={'flex-end mt-10 pointer text-gray'}>
          <span>아이디 / 비밀번호 찾기</span>
        </Link>
    </form> 
  )
}

export default Login;
